import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    autoDismiss: Boolean
  }

  connect () {
    if (this.autoDismissValue) {
      setTimeout(() => {
        this.dismiss()
      }, 5000)
    }
  }

  dismiss () {
    // Fade out animation
    this.element.style.transition = 'opacity 200ms ease-out'
    this.element.style.opacity = '0'

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
